import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useAddBillToMapping from "./useAddBillToMapping";
import Select from "react-select";

const AddBillToMapping = ({ refetch }) => {
  const {
    formik,
    billToMappingState,
    basicData,
    getFieldError,
    handleCloseModal,
  } = useAddBillToMapping({ refetch });

  return (
    <div>
      <div className={`pro-p-4`}>
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Supplier
          </label>
          <Select
            id="supplier_id"
            placeholder={"Select Supplier"}
            className={`pro-input lg ${
              getFieldError("supplier_id") && " error"
            }`}
            classNamePrefix="pro-input"
            name="supplier_id"
            options={basicData?.data?.suppliers || []}
            getOptionValue={(option) => option?._id}
            getOptionLabel={(option) => option?.name}
            value={
              basicData?.data?.suppliers?.find(
                (m) => m._id === formik.values.supplier_id,
              ) || null
            }
            onChange={(value) =>
              formik.setFieldValue("supplier_id", value?._id || "")
            }
            menuPlacement="auto"
            isClearable
          />
          {getFieldError("supplier_id") && (
            <span className="error-text">{getFieldError("supplier_id")}</span>
          )}
        </div>

        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Shop
          </label>
          <Select
            id="shop_id"
            placeholder={"Select Shop"}
            className={`pro-input lg ${getFieldError("shop_id") && " error"}`}
            classNamePrefix="pro-input"
            name="shop_id"
            options={basicData?.data?.shops || []}
            getOptionValue={(option) => option?._id}
            getOptionLabel={(option) => option?.name}
            value={
              basicData?.data?.shops?.find(
                (m) => m._id === formik.values.shop_id,
              ) || null
            }
            onChange={(value) =>
              formik.setFieldValue("shop_id", value?._id || "")
            }
            menuPlacement="auto"
            isClearable
          />
          {getFieldError("shop_id") && (
            <span className="error-text">{getFieldError("shop_id")}</span>
          )}
        </div>

        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Bill To
          </label>
          <Select
            id="bill_to_id"
            placeholder={"Select Bill To"}
            className={`pro-input lg ${
              getFieldError("bill_to_id") && " error"
            }`}
            classNamePrefix="pro-input"
            name="bill_to_id"
            options={basicData?.data?.shops || []}
            getOptionValue={(option) => option?._id}
            getOptionLabel={(option) => option?.name}
            value={
              basicData?.data?.shops?.find(
                (m) => m._id === formik.values.bill_to_id,
              ) || null
            }

            onChange={(value) =>
              formik.setFieldValue("bill_to_id", value?._id || "")
            }
            menuPlacement="auto"
            isClearable
          />
          {getFieldError("bill_to_id") && (
            <span className="error-text">{getFieldError("bill_to_id")}</span>
          )}
        </div>

        <Input
          label={"Remark"}
          type="text"
          id="remark"
          name="remark"
          className={`pro-input lg ${getFieldError("remark") && " error"}`}
          {...formik.getFieldProps("remark")}
          error={getFieldError("remark")}
          errorMessage={getFieldError("remark")}
        />

        <div
          className={`col-12 pro-d-flex pro-justify-end offcanvas-footer-sticky-btn`}
        >
          <Button
            className={"pro-btn-link lg pro-px-5"}
            onClick={handleCloseModal}
            type="button"
          >
            Cancel
          </Button>
          <Button
            className={"pro-btn-primary lg pro-ms-3"}
            type="submit"
            onClick={formik.handleSubmit}
          >
            {billToMappingState?.isEdit ? "Update" : "Create"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddBillToMapping;
